
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...levels]",
      function () {
        return require("private-next-pages/[...levels].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...levels]"])
      });
    }
  